import { render, staticRenderFns } from "./GGButtonsListGroup.vue?vue&type=template&id=fd8dfdd0&scoped=true&"
import script from "./GGButtonsListGroup.vue?vue&type=script&lang=js&"
export * from "./GGButtonsListGroup.vue?vue&type=script&lang=js&"
import style0 from "./GGButtonsListGroup.vue?vue&type=style&index=0&id=fd8dfdd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8dfdd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd8dfdd0')) {
      api.createRecord('fd8dfdd0', component.options)
    } else {
      api.reload('fd8dfdd0', component.options)
    }
    module.hot.accept("./GGButtonsListGroup.vue?vue&type=template&id=fd8dfdd0&scoped=true&", function () {
      api.rerender('fd8dfdd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Elements/GGButtonsListGroup.vue"
export default component.exports